import { render, staticRenderFns } from "./ConsultaCatalago.vue?vue&type=template&id=0ff25aba&scoped=true&"
import script from "./ConsultaCatalago.vue?vue&type=script&lang=js&"
export * from "./ConsultaCatalago.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaCatalago.vue?vue&type=style&index=0&id=0ff25aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff25aba",
  null
  
)

export default component.exports